import reducer from './reducer'

export * from './actions'
export default reducer
